import { NgModule } from '@angular/core';

import { CommonModule } from "@angular/common";
import { AirTicketResourceService } from "./air-ticket-resource.service";
import { ApiResourceModule } from "libraries/service/apiResource/apiResource.module";

@NgModule({
    imports: [
        CommonModule,
        ApiResourceModule,
    ],
    exports: [],
    providers: [
        AirTicketResourceService
    ],
})
export class AirTicketResourceModule {
}
